// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_conf__Config from "../../../../packages/conf/lib/Config.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service from "../../../../proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.js";
import * as Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service from "../../../../proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.js";
import * as Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign from "../../../../proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign.js";
import * as Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service from "../../../../proto/documentapis/gen/buhta_edo_sign_v1alpha1_document_sign_service.js";
import * as Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service from "../../../../proto/documentapis/gen/buhta_edo_sign_v1alpha1_public_sign_service.js";
import * as Curry from "melange.js/curry.js";
import * as Fetch from "melange-fetch/Fetch.js";
import * as Google_rpc__Google_rpc_code from "../../../../proto/third_party/google_rpc/gen/google_rpc_code.js";
import * as Google_rpc__Google_rpc_error_details from "../../../../proto/third_party/google_rpc/gen/google_rpc_error_details.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";

const arrayBufferToBytes = (function(buffer) {
      return new Uint8Array(buffer);
    }
);

const PublicSign = {};

const DocumentSignIntent = {};

const make = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSign.make;

const result = Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign.Buhta.Edo.Sign.V1alpha1.DocumentSignResult.make;

const DocumentSign = {
  make: make,
  result: result
};

const $$Document = {};

const DocumentBatch = {};

const apiEndpointPrefix = "/edo";

function view(tenant, hash, param) {
  const request = Curry._2(Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.GetPublicSignDocumentRequest.make, hash, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.intent);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.PublicSignService.getPublicSignDocument, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.PublicSignService.GetPublicSignDocument.name, undefined, undefined));
}

function listSignDocuments(tenant, hash, param) {
  const request = Curry._2(Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.ListPublicSignDocumentsRequest.make, hash, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.documents;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.PublicSignService.listPublicSignDocuments, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.PublicSignService.ListPublicSignDocuments.name, undefined, undefined));
}

function content(hash, param) {
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const promise = fetch(cfg.grpc_url + ("/api" + (apiEndpointPrefix + ("/sign/v1alpha1/public/" + (hash + "/content")))), Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined));
  const __x = Buhta_core__Grpc.convertJsPromise(promise);
  return $$Promise.flatMap(__x, (function (response) {
                if (response.TAG !== /* Ok */0) {
                  return $$Promise.resolved({
                              TAG: /* Error */1,
                              _0: {
                                statusCode: Curry._1(Google_rpc__Google_rpc_code.Google.Rpc.Code.to_int, /* UNKNOWN */2),
                                errorMessage: "Failed receiving sign content",
                                errorInfo: Curry._4(Google_rpc__Google_rpc_error_details.Google.Rpc.ErrorInfo.make, "0", undefined, undefined, undefined),
                                fieldViolations: /* [] */0
                              }
                            });
                }
                const __x = Buhta_core__Grpc.convertJsPromise(response._0.arrayBuffer());
                return $$Promise.map(__x, (function (res) {
                              if (res.TAG === /* Ok */0) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: arrayBufferToBytes(res._0)
                                      };
                              } else {
                                return {
                                        TAG: /* Error */1,
                                        _0: res._0
                                      };
                              }
                            }));
              }));
}

function bulkSign(tenant, hash, documents, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.documents;
              }), Buhta_core__Grpc.makeRpc(Curry._3(Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.ProcessPublicSignDocumentsRequest.make, hash, documents, undefined), Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.PublicSignService.processPublicSignDocuments, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_sign_v1alpha1_public_sign_service.Buhta.Edo.Sign.V1alpha1.PublicSignService.ProcessPublicSignDocuments.name, undefined, undefined));
}

function gridBatchSignDocuments(tenant, params, batch, param) {
  const request = Curry._3(Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service.Buhta.Edo.Sign.V1alpha1.ListBatchSignDocumentsRequest.make, batch, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.documents;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service.Buhta.Edo.Sign.V1alpha1.DocumentSignService.listBatchSignDocuments, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service.Buhta.Edo.Sign.V1alpha1.DocumentSignService.ListBatchSignDocuments.name, undefined, undefined));
}

function bulkSign$1(tenant, documents, param) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.documents;
              }), Buhta_core__Grpc.makeRpc(Curry._2(Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service.Buhta.Edo.Sign.V1alpha1.BulkSignDocumentsRequest.make, documents, undefined), Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service.Buhta.Edo.Sign.V1alpha1.DocumentSignService.bulkSignDocuments, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_sign_v1alpha1_document_sign_service.Buhta.Edo.Sign.V1alpha1.DocumentSignService.BulkSignDocuments.name, undefined, undefined));
}

const DocumentSignService = {
  gridBatchSignDocuments: gridBatchSignDocuments,
  bulkSign: bulkSign$1
};

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service.Buhta.Edo.$$Document.V1alpha1.ListDocumentsRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.documents;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service.Buhta.Edo.$$Document.V1alpha1.DocumentService.listDocuments, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service.Buhta.Edo.$$Document.V1alpha1.DocumentService.ListDocuments.name, undefined, undefined));
}

function view$1(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._3(Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service.Buhta.Edo.$$Document.V1alpha1.GetDocumentRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.document);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service.Buhta.Edo.$$Document.V1alpha1.DocumentService.getDocument, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_document_v1alpha1_document_service.Buhta.Edo.$$Document.V1alpha1.DocumentService.GetDocument.name, undefined, undefined));
}

const DocumentService = {
  grid: grid,
  view: view$1
};

function grid$1(tenant, params, param) {
  const request = Curry._2(Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service.Buhta.Edo.$$Document.V1alpha1.ListBatchesRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return response.batches;
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service.Buhta.Edo.$$Document.V1alpha1.DocumentBatchService.listBatches, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service.Buhta.Edo.$$Document.V1alpha1.DocumentBatchService.ListBatches.name, undefined, undefined));
}

function view$2(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  const request = Curry._3(Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service.Buhta.Edo.$$Document.V1alpha1.GetBatchRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.batch);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service.Buhta.Edo.$$Document.V1alpha1.DocumentBatchService.getBatch, undefined, tenant, undefined, apiEndpointPrefix + Buhta_documentapis__Buhta_edo_document_v1alpha1_document_batch_service.Buhta.Edo.$$Document.V1alpha1.DocumentBatchService.GetBatch.name, undefined, undefined));
}

const DocumentBatchService = {
  grid: grid$1,
  view: view$2
};

const PublicSignService = {
  view: view,
  content: content,
  listSignDocuments: listSignDocuments,
  bulkSign: bulkSign
};

export {
  PublicSign ,
  DocumentSignIntent ,
  DocumentSign ,
  $$Document ,
  DocumentBatch ,
  PublicSignService ,
  DocumentSignService ,
  DocumentService ,
  DocumentBatchService ,
}
/* Buhta_conf__Config Not a pure module */
